import { h } from 'preact'
import { useSelector } from 'react-redux'
import PagePrice from '../../PagePrice'
import { useTranslations } from '../../../hooks/useTranslations'
import { transactionDetailsSelector } from '../../../redux/slice/transactionDetailsSlice'
import './styles.scss'

const PaymentTotalPrice = () => {
  const { amount, currency, overrideAmount, culture } = useSelector(
    transactionDetailsSelector
  )

  const l10n = useTranslations()

  return (
    <div
      className="payment-price total-price mfe-component"
      data-testid="total-price"
    >
      <PagePrice
        {...{ amount: overrideAmount || amount, currency, culture }}
        className="xlarge"
      />
      <div className="total-price__title lead text">
        {l10n.t('Total price')}
      </div>
    </div>
  )
}

export default PaymentTotalPrice
